var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Card, DatePicker, Input, Select, Space, Table, Typography } from 'antd';
import dayjs from 'dayjs';
import { useGetProductPurchasesListQuery, useGetProductPurchasesStatsByProductQuery, } from '@/services/productPurchasesApi';
import { useGetRestaurantByIdQuery } from '@/services/restaurantsApi';
var Title = Typography.Title, Text = Typography.Text;
var PERIOD_OPTIONS = [
    { value: 'день', label: 'День' },
    { value: 'неделя', label: 'Неделя' },
    { value: 'месяц', label: 'Месяц' },
    { value: 'год', label: 'Год' },
    { value: 'range', label: 'Промежуток' },
    { value: 'all', label: 'Все время' },
];
var formatInt = function (n) { return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(n || 0); };
var ProductStatsTab = function (_a) {
    var _b, _c, _d, _e, _f;
    var restId = _a.restId;
    var _g = useState('месяц'), period = _g[0], setPeriod = _g[1];
    var _h = useState(function () { return [dayjs().startOf('month'), dayjs().endOf('month')]; }), range = _h[0], setRange = _h[1];
    var _j = useState(undefined), productId = _j[0], setProductId = _j[1];
    var _k = useState(undefined), userId = _k[0], setUserId = _k[1];
    var restaurant = useGetRestaurantByIdQuery(Number(restId)).data;
    var productOptions = ((_b = restaurant === null || restaurant === void 0 ? void 0 : restaurant.product) !== null && _b !== void 0 ? _b : []).map(function (p) {
        return ({
            value: String(p.id),
            label: "".concat(p.name, " (#").concat(p.id, ")"),
        });
    });
    var queryParams = useMemo(function () {
        var _a, _b;
        var base = {
            restaurantId: String(restId),
            period: period,
            productId: productId,
            userId: userId,
        };
        if (period === 'range') {
            base.dateFrom = (_a = range === null || range === void 0 ? void 0 : range[0]) === null || _a === void 0 ? void 0 : _a.format('YYYY-MM-DD');
            base.dateTo = (_b = range === null || range === void 0 ? void 0 : range[1]) === null || _b === void 0 ? void 0 : _b.format('YYYY-MM-DD');
        }
        else if (period !== 'all') {
            base.date = dayjs().format('YYYY-MM-DD');
        }
        return base;
    }, [period, range, restId, productId, userId]);
    var _l = useGetProductPurchasesStatsByProductQuery(queryParams), byProduct = _l.data, loadingByProduct = _l.isLoading;
    var _m = useGetProductPurchasesListQuery(queryParams), list = _m.data, loadingList = _m.isLoading;
    var productRows = ((_c = byProduct === null || byProduct === void 0 ? void 0 : byProduct.items) !== null && _c !== void 0 ? _c : []).map(function (x, idx) {
        var _a;
        return ({
            key: (_a = x.productId) !== null && _a !== void 0 ? _a : "".concat(x.productName, "-").concat(idx),
            productId: x.productId,
            productName: x.productName,
            coins: x.coins,
            count: x.count,
        });
    });
    var listRows = ((_d = list === null || list === void 0 ? void 0 : list.items) !== null && _d !== void 0 ? _d : []).map(function (x) {
        return ({
            key: x.id,
            createdAt: x.createdAt,
            userId: x.userId,
            userName: x.userName,
            coins: x.coins,
            productId: x.productId,
            productName: x.productName,
        });
    });
    return (_jsx("div", __assign({ style: { width: '100%', paddingInline: 40 } }, { children: _jsxs(Space, __assign({ direction: "vertical", size: 16, style: { width: '100%' } }, { children: [_jsxs("div", __assign({ style: { display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' } }, { children: [_jsx(Title, __assign({ level: 4, style: { margin: 0, fontFamily: 'Montserrat Regular' } }, { children: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u043F\u043E \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430\u043C (\u043F\u043E\u043A\u0443\u043F\u043A\u0438 \u0437\u0430 eGo Coin)" })), _jsxs(Space, __assign({ wrap: true }, { children: [_jsx(Select, { value: period, options: PERIOD_OPTIONS, style: { width: 170 }, onChange: function (v) { return setPeriod(v); } }), _jsx(Select, { allowClear: true, placeholder: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442", value: productId, options: productOptions, style: { width: 280 }, onChange: function (v) { return setProductId(v); }, showSearch: true, optionFilterProp: "label", filterOption: function (input, option) { var _a; return String((_a = option === null || option === void 0 ? void 0 : option.label) !== null && _a !== void 0 ? _a : '').toLowerCase().includes(input.toLowerCase()); } }), _jsx(Input, { value: userId, onChange: function (e) { return setUserId(e.target.value.replace(/[^\d]/g, '') || undefined); }, placeholder: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C (ID)", style: { width: 180 }, inputMode: "numeric" }), _jsx(DatePicker.RangePicker, { value: range, onChange: function (v) {
                                        if (v && v[0] && v[1])
                                            setRange([v[0], v[1]]);
                                    }, disabled: period !== 'range', format: "DD.MM.YYYY", allowClear: false })] }))] })), _jsx(Card, { children: _jsxs(Space, __assign({ size: 24, wrap: true }, { children: [_jsxs("div", { children: [_jsx(Text, __assign({ type: "secondary" }, { children: "\u041A\u043E\u0438\u043D\u043E\u0432 \u043F\u043E\u0442\u0440\u0430\u0447\u0435\u043D\u043E" })), _jsx("div", __assign({ style: { fontSize: 18, fontWeight: 600 } }, { children: formatInt((_e = byProduct === null || byProduct === void 0 ? void 0 : byProduct.totalCoins) !== null && _e !== void 0 ? _e : 0) }))] }), _jsxs("div", { children: [_jsx(Text, __assign({ type: "secondary" }, { children: "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u0439" })), _jsx("div", __assign({ style: { fontSize: 18, fontWeight: 600 } }, { children: formatInt((_f = byProduct === null || byProduct === void 0 ? void 0 : byProduct.count) !== null && _f !== void 0 ? _f : 0) }))] })] })) }), _jsx(Card, __assign({ title: "\u0422\u043E\u043F \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432 \u0437\u0430 \u043F\u0435\u0440\u0438\u043E\u0434" }, { children: _jsx(Table, { loading: loadingByProduct, dataSource: productRows, pagination: false, size: "small", columns: [
                            {
                                title: 'Продукт',
                                dataIndex: 'productName',
                                render: function (_, row) {
                                    return row.productId != null ? "".concat(row.productName, " (#").concat(row.productId, ")") : row.productName;
                                },
                            },
                            {
                                title: 'Операций',
                                dataIndex: 'count',
                                width: 110,
                                render: function (v) { return formatInt(v); },
                            },
                            {
                                title: 'Коинов',
                                dataIndex: 'coins',
                                width: 140,
                                render: function (v) { return formatInt(v); },
                            },
                        ] }) })), _jsx(Card, __assign({ title: "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 (\u0434\u0435\u0442\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F)" }, { children: _jsx(Table, { loading: loadingList, dataSource: listRows, size: "small", pagination: { pageSize: 25 }, columns: [
                            {
                                title: 'Дата/время',
                                dataIndex: 'createdAt',
                                width: 170,
                                render: function (v) { return (v ? dayjs(v).format('DD.MM.YYYY HH:mm') : '—'); },
                            },
                            {
                                title: 'Пользователь',
                                dataIndex: 'userName',
                                render: function (_, row) { return row.userName ? "".concat(row.userName, " (#").concat(row.userId, ")") : "#".concat(row.userId); },
                            },
                            {
                                title: 'Продукт',
                                dataIndex: 'productName',
                                render: function (_, row) {
                                    return row.productId != null ? "".concat(row.productName, " (#").concat(row.productId, ")") : row.productName;
                                },
                            },
                            {
                                title: 'Коинов',
                                dataIndex: 'coins',
                                width: 120,
                                render: function (v) { return (v != null ? formatInt(v) : '—'); },
                            },
                        ] }) }))] })) })));
};
export default ProductStatsTab;
